import styled from 'styled-components';

export const Container = styled.section`
  @media (min-width: 996px) {
    margin-top: 113px;
    padding: 90px 14%;
    display: flex;
    justify-content: space-between;
    gap: 12%;
  }
`;
